<template>
    <div class="vip">
        <div class="head" :class="{ pointer: isView }" @click="onChange">
            <div class="title">
                <div class="icon">
                    <div class="icon-box"></div>
                </div>
                <div class="sign">
                    {{ `${detail.memberRightsInterests && detail.memberRightsInterests.memberType === 0 ? '权益' : 'VIP权益：'}` }}
                </div>
                <div class="name">{{ detail.name }}</div>
            </div>
            <div class="view" v-if="isView">
                <span>查看权益</span>
                <span class="arrow" :class="{ active: show }"></span>
            </div>
        </div>
        <transition-collapse :show="show">
            <div class="condition">
                <div class="condition-title">{{ detail.memberTypeStr }}的患者</div>
                <div class="condition-box">
                    <div class="p">
                        <span>权益可用次数：</span>
                        <span>{{ detail.quantity - detail.useNum }}次</span>
                    </div>
                    <div class="p">
                        <span>权益使用期限：</span>
                        <span>{{ detail.timeLimitStr }}</span>
                    </div>
                </div>
            </div>
        </transition-collapse>
    </div>
</template>
<script>
import transitionCollapse from '@/components/transition/collapse.vue'
export default {
    name: 'vip',
    components: {
        transitionCollapse
    },
    props: {
        id: [String, Number],
        detail: {
            type: Object,
            default: () => ({})
        },
        isView: { // 是否查看
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false
        }
    },
    computed: {

    },
    mounted() {

    },
    destroyed() {

    },
    methods: {
        onChange() {
            if (!this.isView) return false;
            this.show = !this.show;
        }
    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
.vip {
    font-size: 15px;
    .head {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        user-select: none;
        cursor: default;
        &.pointer {
            cursor: pointer;
        }
        .title {
            flex: 1;
            display: flex;
            align-items: center;
            background: linear-gradient(90deg, #fce3c8, #fce3c8 50%, transparent 100%);
            color: #ff6712;
            border-radius: 4px;
            max-width: 85%;
            font-weight: 500;
            .icon,
            .sign {
                flex: none;
            }
            .icon {
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                &-box {
                    width: 20px;
                    height: 20px;
                    background: url(@/assets/images/patient/vip.svg) center center / 100% 100% no-repeat;
                }
            }
            .name {
                word-break: break-all;
            }
        }
        .view {
            flex: none;
            margin-left: 10px;
            display: flex;
            align-items: center;
            color: #3763fc;
            height: 30px;
            .arrow {
                width: 0;
                height: 0;
                border: 6px solid transparent;
                border-top-color: #3880ed;
                border-bottom-width: 0;
                margin-left: 5px;
                transform: rotate(-90deg);
                transition: .3s;
                &.active {
                    transform: rotate(0);
                }
            }
        }
    }
    .condition {
        border: 1px solid #ddd;
        margin-top: 10px;
        padding: 15px;
        border-radius: 6px;
        &-box {
            font-weight: bold;
            .p {
                margin-top: 10px;
            }
        }
    }
}
</style>